import { render, staticRenderFns } from "./Forgot.vue?vue&type=template&id=8301d3b2&scoped=true&"
import script from "./Forgot.vue?vue&type=script&lang=ts&"
export * from "./Forgot.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8301d3b2",
  null
  
)

export default component.exports